import { defineComponent as _defineComponent } from 'vue'
import { ICON_SET, type IconName } from './WheelsSvgIcon.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsSvgIcon',
  props: {
    size: { default: 24 },
    icon: null
  },
  setup(__props: any) {

const props = __props as { size: number | string, icon: IconName };



// defineOptions({
//   name: 'SvgIcon'
// })

return { __sfc: true,props, ICON_SET }
}

})